import { useEffect, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Button, FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import { setBannerMsg, toggleBanner, toggleModal } from './groupsListSlice'
import { useCreateGroupMutation } from './groupListApiSlice'
import { getGroupCount, getGroupList } from './groupListAction'
import { useSnackbar } from 'notistack'
import { setGroupsLoading } from './groupsListSlice'

const ModalCreateGroup = () => {
  const dispatch = useDispatch()
  const { isOpenModal } = useSelector((s) => s.groupsList)
  const [name, setName] = useState('')
  const [errMsg, setErrMsg] = useState('')
  const [createGroup, result] = useCreateGroupMutation()
  const { enqueueSnackbar } = useSnackbar()

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const { data } = await createGroup({ name: name }).unwrap()
      if (data?.data?.meta?.error) {
        throw data
      } else {
        enqueueSnackbar('Berhasil menambahkan grup', { variant: 'success' })
        dispatch(toggleModal())
        dispatch(setGroupsLoading(true))
        setTimeout(() => {
          dispatch(getGroupCount())
          dispatch(getGroupList({ page: 0, size: 10 }))
        }, 1500)
      }
    } catch (error) {
      setErrMsg(error?.data?.meta?.message)
    }
  }

  useEffect(() => {
    if (!isOpenModal) {
      setName(null)
    }
  }, [isOpenModal])

  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpenModal}
      toggle={() => {
        dispatch(toggleModal())
        setErrMsg('')
      }}
      autoFocus={false}
      data-testid="farmer-group-create-modal"
    >
      <ModalBody>
        <h5>Buat grup</h5>
        <FormGroup>
          <Label>Nama grup</Label>
          <Input
            autoFocus={true}
            value={name ?? ''}
            onChange={(e) => {
              setName(e.target.value)
              setErrMsg('')
            }}
            placeholder="Contoh: Petani Jakarta Selatan"
            data-testid="farmer-form-group-name"
          />
        </FormGroup>
        {errMsg && (
          <small className="text-danger">
            <AlertCircle size={15} /> {errMsg}
          </small>
        )}
        <div className="d-flex gap-3">
          <Button
            onClick={() => {
              dispatch(toggleModal())
              setErrMsg('')
            }}
            disabled={result?.isLoading}
            color="primary"
            outline
            block
            className="btn-cancel"
            data-testid="farmer-group-create-cancel-button"
          >
            Batal
          </Button>
          <Button
            disabled={result?.isLoading}
            onClick={handleSubmit}
            color="primary"
            block
            data-testid="farmer-group-create-submit-button"
          >
            Buat Grup
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalCreateGroup
